import { jsx as _jsx } from "react/jsx-runtime";
import styles from './MakePhotoIcon.module.scss';
import { ReactComponent as MakePhoto } from '../../assets/icons/make-photo-icon.svg';
import cn from 'classnames';
import { useSelector } from 'react-redux';
const MakePhotoIcon = () => {
    const darkMode = useSelector((state) => state.settings.darkMode);
    return (_jsx("div", Object.assign({ className: cn(styles.element, darkMode && styles['isDarkMode']) }, { children: _jsx(MakePhoto, {}) })));
};
export default MakePhotoIcon;
